module.exports = __webpack_public_path__ + "img/11_24.c10ad114.png";